import axios from "axios";
import { getActiveUsers } from "./GetActiveUsersAction";
import {
  removeUserRolesRequested,
  removeUserRolesRequestSucceeded,
  removeUserRolesRequestFailed,
} from "../slices/RemoveUserRolesSlice";

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/User/RemoveUserRoles`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const RemoveUserRoles = (idUser, roleIds) => async (dispatch) => {
  try {
    dispatch(removeUserRolesRequested());

    const postData = {
      idUser: Number(idUser),
      roleIds: roleIds.map((id) => Number(id)),
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(apiUrl, postData, axiosConfig);

    if (response.data === true) {
      dispatch(removeUserRolesRequestSucceeded(response.data));
      await dispatch(getActiveUsers());
      return { success: true, message: "Roles removed successfully" };
    }

    const errorMessage =
      "The roles could not be removed. The user may not exist or the roles are not assigned.";
    dispatch(removeUserRolesRequestFailed(errorMessage));

    return { success: false, message: errorMessage };
  } catch (error) {
    const errorMessage = error.response?.data || error.message;
    dispatch(removeUserRolesRequestFailed(errorMessage));

    return {
      success: false,
      message: errorMessage,
    };
  }
};
